import React, {Component} from 'react';
import {Row, Col, Tooltip, Card, CardHeader, CardBody, Button, CardFooter, Table, Badge, ButtonToolbar, CardTitle,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import moment from 'moment';

import Oneline from '../../Overview/Oneline';
import Generators from '../../GeneratorSchema/Generators';
import Utilities from '../../UtilitySchema/Utilities';
import System from '../../SystemSchema/System';
import Ties from '../../TieSchema/Ties';
import SystemCharts from '../../SystemSchema/SystemCharts';
import ContainerDimensions from 'react-container-dimensions'
import {ajaxWrapperGet} from "../../../../utils/deviceAPI";
import {isDeviceOnline} from "../../../../utils/isDeviceOnline";
import DeviceOffline from '../../DeviceMessages/DeviceOffline';
import LoadingIndicator from '../../../../utils/LoadingIndicator';
//google maps

const graphingVoltage = [0, 0, 0, 0, 0, 0, 0];
const graphingFreq = [0, 0, 0, 0, 0, 0, 0];
const graphingKw = [0, 0, 0, 0, 0, 0, 0];
const graphingKvar = [0, 0, 0, 0, 0, 0, 0];


class BeaverCreek extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [
                {

                    initializer: 0
                },
                {
                    initializer: 0,
                }

            ],
            loading: true,
            overViewZoomLevel: 1,
            tooltipOpen: [false, false, false]
        };
    }
    overviewControls(control) {
        let currentZoomLevel = this.state.overViewZoomLevel;

        switch(control) {
            case "zoomin":
                currentZoomLevel += .2;
                break;
            case "zoomout":
                currentZoomLevel -= .2;
                break;
            case "zoomreset":
                currentZoomLevel = 1;
                break;
        }
        this.setState({
            overViewZoomLevel: currentZoomLevel
        });
    }
    toggle(i) {
        const newArray = this.state.tooltipOpen.map((element, index) => {
            return (index === i ? !element : false);
        });
        this.setState({
            tooltipOpen: newArray
        });
    }
    componentDidMount() {
        this.tick();
        this.timerID = setInterval(
            () => this.tick(),
            10000
        );
    }
    componentWillUnmount(){
        clearInterval(this.timerID);
    }
    tick(device = this.props.device) {
        ajaxWrapperGet('/api/deviceOverviewDataBeaverCreek',device).then((data) => {
            console.log(data);
            this.setState({
                data,
                loading: false
            });

        });
    }
    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        const data = this.state.data;
        const systemVoltage = 4160;
        const generator1 = data['generator1'][0];
        const generator2 = data['generator2'][0];
        const utility1 = data['utility1'][0];
        const utility2 = data['utility2'][0];
        const system = data['system'][0];
        const systemStatus = data['systemStatus'];
        const systemStatus2 = data['systemStatus2'];

        //Graphing
        let voltsAvg = Math.round(((system.MeterVoltsAB + system.MeterVoltsBC + system.MeterVoltsCA) / 3) * 100) / 100;
        graphingVoltage.splice(0,1);
        graphingVoltage.push(voltsAvg);

        let freq = Math.round(system.MeterFreq * 100) / 10000;
        graphingFreq.splice(0,1);
        graphingFreq.push(freq);

        let kw = system.MeterKw;
        graphingKw.splice(0,1);
        graphingKw.push(kw);

        let kvar = system.MeterKvar;
        graphingKvar.splice(0,1);
        graphingKvar.push(kvar);

        let systemGenWarmup = system['systemGenWarmup'];
        let systemN1Exit = system['systemN1Exit'];
        let systemN2Exit = system['systemN2Exit'];



        let timeNow = moment().format('MMMM Do YYYY, h:mm:ss a');

        return (
            <div className="containerAnimation">
                <div className="fadeInUp">
                    <Row>
                        <Col xs="12" lg="12">
                            <Card>
                                <CardBody className="card-body">
                                    <Row className="pb-2">
                                        <Col sm="12">
                                            <CardTitle className="mb-0">Overview Online</CardTitle>
                                            <div className="small text-muted">{timeNow}</div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-4 pb-3" id="overviewGenerated">
                                        <ContainerDimensions>
                                            {({width, height}) =>
                                                <Oneline innerWidth={width} data={data} overViewZoomLevel={this.state.overViewZoomLevel}/>

                                            }
                                        </ContainerDimensions>
                                    </Row>
                                    <Row className="pb-2">
                                        <Col sm="12" className="d-none d-sm-inline-block">
                                            <Button color="secondary" onClick={() => {this.overviewControls('zoomin');}} id="Tooltip-zoomin"><i className="fa fa-search-plus"></i></Button>
                                            <Button color="secondary" onClick={() => {this.overviewControls('zoomout');}} id="Tooltip-zoomout"><i className="fa fa-search-minus"></i></Button>
                                            <Button color="secondary" onClick={() => {this.overviewControls('zoomreset');}} id="Tooltip-zoomreset"><i className="fa fa-window-restore"></i></Button>
                                            <Tooltip placement="bottom" isOpen={this.state.tooltipOpen[0]} target={'Tooltip-zoomin'} toggle={() => {this.toggle(0)}}>
                                                Zoom In
                                            </Tooltip>
                                            <Tooltip placement="bottom" isOpen={this.state.tooltipOpen[1]} target={'Tooltip-zoomout'} toggle={() => {this.toggle(1)}}>
                                                Zoom Out
                                            </Tooltip>
                                            <Tooltip placement="bottom" isOpen={this.state.tooltipOpen[2]} target={'Tooltip-zoomreset'} toggle={() => {this.toggle(2)}}>
                                                Reset Zoom Level
                                            </Tooltip>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" sm="12" lg="3" xl="3">
                            <SystemCharts header="System Voltage"
                                          color="primary"
                                          graphingAvg = {voltsAvg}
                                          graphingArray = {graphingVoltage}
                            />
                        </Col>
                        <Col xs="12" sm="12" lg="3" xl="3">
                            <SystemCharts header="System Freq"
                                          color="warning"
                                          graphingAvg = {freq}
                                          graphingArray = {graphingFreq }
                            />
                        </Col>
                        <Col xs="12" sm="12" lg="3" xl="3">
                            <SystemCharts header="System Kw"
                                          color="info"
                                          graphingAvg = {kw}
                                          graphingArray = {graphingKw}
                            />
                        </Col>
                        <Col xs="12" sm="12" lg="3" xl="3">
                            <SystemCharts header="System Kvar"
                                          color="danger"
                                          graphingAvg = {kvar}
                                          graphingArray = {graphingKvar}
                            />
                        </Col>
                    </Row>
                    <Row>

                        <Col xs="12" sm="12" lg="12" xl="12">
                            <System header="System"
                                    mainText="Information"
                                    icon="fa fa-cogs"
                                    color="primary"
                                    MeterPf = {system.MeterPf}
                                    MeterAmpsA = {system.MeterAmpsA}
                                    MeterAmpsB = {system.MeterAmpsB}
                                    MeterAmpsC = {system.MeterAmpsC}
                                    MeterFreq = {system.MeterFreq}
                                    MeterVoltsAB = {system.MeterVoltsAB}
                                    MeterVoltsBC = {system.MeterVoltsBC}
                                    MeterVoltsCA = {system.MeterVoltsCA}
                                    MeterKw = {system.MeterKw}
                                    MeterKvar = {system.MeterKvar}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" sm="12" lg="12" xl="12">
                            <Card>
                                <CardBody className="card-body">
                                    <Row className="pb-2">
                                        <Col sm="12">
                                            <CardTitle className="mb-0">System Status</CardTitle>
                                            <div className="small text-muted">Current status of the system, switches and timers</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <ul className="icons-list mb-3 list-inline">
                                                {systemStatus.map(function(alarm,index){
                                                    if (alarm.message !== "-" && alarm.status === 1) return (
                                                        <li key={index} className="mb-3 mt-3 listSiteItems">
                                                            <i className={"fa fa-check-square-o " + (alarm.status === 1 ? "text-success" : "text-danger")}></i>
                                                            <div className="desc-n">
                                                                <div className="title">{alarm.message}</div>
                                                                <div className="small text-muted text-lowercase pb-3">status</div>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                                {Math.floor(systemGenWarmup / 100) <= 4 ?
                                                    <li className="mb-3 mt-3 listSiteItems">
                                                        <i className="fa fa-clock-o text-warning"></i>
                                                        <div className="desc-n">
                                                            <div className="title">Gen Warmup Timer - {systemGenWarmup / 100} minutes/seconds</div>
                                                            <div className="small text-muted text-lowercase pb-3">timer</div>
                                                        </div>
                                                    </li>
                                                    : ""
                                                }
                                                {Math.floor(systemN1Exit / 100) <= 14 ?
                                                    <li className="mb-3 mt-3 listSiteItems">
                                                        <i className="fa fa-clock-o text-warning"></i>
                                                        <div className="desc-n">
                                                            <div className="title">Utility 1 Retransfer - {systemN1Exit / 100} minutes/seconds</div>
                                                            <div className="small text-muted text-lowercase pb-3">timer</div>
                                                        </div>
                                                    </li>
                                                    : ""
                                                }
                                                {Math.floor(systemN2Exit / 100) <= 14 ?
                                                    <li className="mb-3 mt-3 listSiteItems">
                                                        <i className="fa fa-clock-o text-warning"></i>
                                                        <div className="desc-n">
                                                            <div className="title">Utility 2 Retransfer - {systemN2Exit / 100} minutes/seconds</div>
                                                            <div className="small text-muted text-lowercase pb-3">timer</div>
                                                        </div>
                                                    </li>
                                                    : ""
                                                }
                                            </ul>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" sm="6" lg="6" xl="3">
                            <Generators header="Generator 1"
                                        mainText="Information"
                                        icon="fa fa-cogs"
                                        color="primary"
                                        systemVoltage={4161}
                                        MeterPfRot={generator1.MeterPfRot}
                                        MeterPf={generator1.MeterPf}
                                        MeterAmpsA={generator1.MeterAmpsA}
                                        MeterAmpsB={generator1.MeterAmpsB}
                                        MeterAmpsC={generator1.MeterAmpsC}
                                        MeterFreqRef={generator1.MeterFreqRef}
                                        MeterVoltsAB={generator1.MeterVoltsAB}
                                        MeterVoltsBC={generator1.MeterVoltsBC}
                                        MeterVoltsCA={generator1.MeterVoltsCA}
                                        MeterVoltsRef={generator1.MeterVoltsRef}
                                        MeterVoltsKw={generator1.MeterVoltsKw}
                                        MeterVoltsKvar={generator1.MeterVoltsKvar}
                                        MeterFreq={generator1.MeterFreq}
                                        MeterPhaAngleDiff={generator1.MeterPhaAngleDiff}
                                        WarmupTimer={generator1.WarmupTimer}
                                        StatusAndControl={generator1.StatusAndControl}
                                        EngineOilPress={generator1.EngineOilPress}
                                        EngineCoolantTemp={generator1.EngineCoolantTemp}
                                        EngineBoostPress={generator1.EngineBoostPress}
                                        EngineRPM={generator1.EngineRPM}
                                        EngineBattVolts={generator1.EngineBattVolts}
                                        EngineFuelPress={generator1.EngineFuelPress}
                                        EngineCrankcasePress={generator1.EngineCrankcasePress}
                                        EngineOilDiffPress={generator1.EngineOilDiffPress}
                                        EngineFuelDiffPress={generator1.EngineFuelDiffPress}
                                        EngineAtmosphericPress={generator1.EngineAtmosphericPress}
                                        EngineIntakeAirDiffPress={generator1.EngineIntakeAirDiffPress}
                                        EngineFuelConsumption={generator1.EngineFuelConsumption}
                                        EngineLeftExhaustTemp={generator1.EngineLeftExhaustTemp}
                                        EngineRightExhaustTemp={generator1.EngineRightExhaustTemp}
                                        breakerAux={systemStatus2[4]}
                            />
                        </Col>
                        <Col xs="12" sm="6" lg="6" xl="3">
                            <Generators header="Generator 2"
                                        mainText="Information"
                                        icon="fa fa-cogs"
                                        color="primary"
                                        systemVoltage={4161}
                                        MeterPfRot={generator2.MeterPfRot}
                                        MeterPf={generator2.MeterPf}
                                        MeterAmpsA={generator2.MeterAmpsA}
                                        MeterAmpsB={generator2.MeterAmpsB}
                                        MeterAmpsC={generator2.MeterAmpsC}
                                        MeterFreqRef={generator2.MeterFreqRef}
                                        MeterVoltsAB={generator2.MeterVoltsAB}
                                        MeterVoltsBC={generator2.MeterVoltsBC}
                                        MeterVoltsCA={generator2.MeterVoltsCA}
                                        MeterVoltsRef={generator2.MeterVoltsRef}
                                        MeterVoltsKw={generator2.MeterVoltsKw}
                                        MeterVoltsKvar={generator2.MeterVoltsKvar}
                                        MeterFreq={generator2.MeterFreq}
                                        MeterPhaAngleDiff={generator2.MeterPhaAngleDiff}
                                        WarmupTimer={generator2.WarmupTimer}
                                        StatusAndControl={generator2.StatusAndControl}
                                        EngineOilPress={generator2.EngineOilPress}
                                        EngineCoolantTemp={generator2.EngineCoolantTemp}
                                        EngineBoostPress={generator2.EngineBoostPress}
                                        EngineRPM={generator2.EngineRPM}
                                        EngineBattVolts={generator2.EngineBattVolts}
                                        EngineFuelPress={generator2.EngineFuelPress}
                                        EngineCrankcasePress={generator2.EngineCrankcasePress}
                                        EngineOilDiffPress={generator2.EngineOilDiffPress}
                                        EngineFuelDiffPress={generator2.EngineFuelDiffPress}
                                        EngineAtmosphericPress={generator2.EngineAtmosphericPress}
                                        EngineIntakeAirDiffPress={generator2.EngineIntakeAirDiffPress}
                                        EngineFuelConsumption={generator2.EngineFuelConsumption}
                                        EngineLeftExhaustTemp={generator2.EngineLeftExhaustTemp}
                                        EngineRightExhaustTemp={generator2.EngineRightExhaustTemp}
                                        breakerAux={systemStatus2[5]}
                            />
                        </Col>
                        <Col xs="12" sm="6" lg="6" xl="3">
                            <Utilities header="Utility 1"
                                       mainText="Information"
                                       icon="fa fa-bolt"
                                       color="primary"
                                       systemVoltage={4161}
                                       MeterPf={utility1.MeterPf}
                                       MeterAmpsA={utility1.MeterAmpsA}
                                       MeterAmpsB={utility1.MeterAmpsB}
                                       MeterAmpsC={utility1.MeterAmpsC}
                                       MeterFreqRef={utility1.MeterFreqRef}
                                       MeterVoltsAB={utility1.MeterVoltsAB}
                                       MeterVoltsBC={utility1.MeterVoltsBC}
                                       MeterVoltsCA={utility1.MeterVoltsCA}
                                       MeterVoltsRef={utility1.MeterVoltsRef}
                                       MeterKw={utility1.MeterKw}
                                       MeterKvar={utility1.MeterKvar}
                                       MeterSpare1={utility1.MeterSpare1}
                                       MeterFreq={utility1.MeterFreq}
                                       breakerAux={systemStatus2[0]}
                            />
                        </Col>
                        <Col xs="12" sm="6" lg="6" xl="3">
                            <Utilities header="Utility 2"
                                       mainText="Information"
                                       icon="fa fa-bolt"
                                       color="primary"
                                       systemVoltage={4161}
                                       MeterPf={utility2.MeterPf}
                                       MeterAmpsA={utility2.MeterAmpsA}
                                       MeterAmpsB={utility2.MeterAmpsB}
                                       MeterAmpsC={utility2.MeterAmpsC}
                                       MeterFreqRef={utility2.MeterFreqRef}
                                       MeterVoltsAB={utility2.MeterVoltsAB}
                                       MeterVoltsBC={utility2.MeterVoltsBC}
                                       MeterVoltsCA={utility2.MeterVoltsCA}
                                       MeterVoltsRef={utility2.MeterVoltsRef}
                                       MeterKw={utility2.MeterKw}
                                       MeterKvar={utility2.MeterKvar}
                                       MeterSpare1={utility2.MeterSpare1}
                                       MeterFreq={utility2.MeterFreq}
                                       breakerAux={systemStatus2[2]}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" sm="6" lg="6" xl="6">
                            <Ties header="Tie 1"
                                  mainText="Information"
                                  icon="fa fa-bolt"
                                  color="primary"
                                  breakerAux={systemStatus2[1]}
                            />
                        </Col>
                        <Col xs="12" sm="6" lg="6" xl="6">
                            <Ties header="Tie 2"
                                  mainText="Information"
                                  icon="fa fa-bolt"
                                  color="primary"
                                  breakerAux={systemStatus2[3]}
                            />
                        </Col>
                    </Row>

                </div>
            </div>


        )
    }
}

export default BeaverCreek;





// WEBPACK FOOTER //
// ./src/views/site/Overview/Templates/BeaverCreek.js